var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 281.42 30.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05EA\\u05E4\\u05E8\\u05D9\\u05D8_\\u05E0\\u05E4\\u05EA\\u05D7",
    "data-name": "\\u05EA\\u05E4\\u05E8\\u05D9\\u05D8 \\u05E0\\u05E4\\u05EA\\u05D7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.2,9.51H0V1.2h27.61v28.81h-9.41V9.51ZM.34,14.79h9.41v15.22H.34v-15.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.67,9.51h-7.44v20.5h-14.31v-8.31h4.9v-12.2h-3.46V1.2h29.72v28.81h-9.41V9.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.79,1.2h9.41v28.81h-9.41V1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.98,30.01h-9.41v-14.41c0-8.93,6.63-15.37,15.65-15.37s15.51,6.43,15.51,15.37c0,12.58-9.32,17.62-19.4,13.78l2.3-7.73c3.99,1.54,7.68-.24,7.68-6.05,0-3.94-2.59-6.72-6.1-6.72s-6.24,2.78-6.24,6.72v14.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.36,1.2v28.81h-28.48v-8.31h4.99V1.2h9.41v20.5h4.66V1.2h9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.88,9.51h-18.2V1.2h27.61v28.81h-9.41V9.51ZM146.01,14.79h9.41v15.22h-9.41v-15.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.26,9.51h-7.44v20.5h-14.31v-8.31h4.9v-12.2h-3.46V1.2h29.72v28.81h-9.41V9.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.38,1.2h9.41v28.81h-9.41V1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.49,1.2h9.41v28.81h-9.41V1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.08,21.7h11.38l-12.77-15.7,6.87-5.81,8.55,10.85,8.6-11.04,6.72,5.09-9.94,12.77,9.46,12v.14h-28.86v-8.31Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/צוות העמותהmdpi.2fd9f00dca130322e6db73cb3ec19897.svg";
export { ForwardRef as ReactComponent };